<template>
    <v-col>
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn d-flex justify-space-between">
                <h1>{{ $t("sites.edit_site") }}</h1>
                <v-btn
                    class="delete"
                    elevation="0"
                    small
                    dark
                    @click="site_confirm_dialog = true"
                >
                    <v-icon size="16" class="mr-1">mdi-delete</v-icon>
                    {{ $t("global.delete") }}
                </v-btn>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_edit_sites">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("sites.info_site") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="designation"
                                    :label="$t('sites.designation')"
                                    dense
                                    disabled
                                    hide-details="auto"
                                    light
                                    outlined
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="code"
                                    :label="$t('sites.code')"
                                    dense
                                    disabled
                                    hide-details="auto"
                                    light
                                    outlined
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h2>{{ $t("sites.models_codes") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                        <v-col class="text-lg-right" cols="12" md="6">
                            <v-btn
                                color="secondary"
                                class="btn-add"
                                elevation="0"
                                @click="showNewCodeModelForm = true"
                            >
                                <v-icon size="18">mdi-plus</v-icon>
                                {{ $t('global.add') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="headers"
                                    :items="models"
                                    :items-per-page="-1"
                                    :loading="modelLoading"
                                    hide-default-footer
                                >
                                    <template #[`item.actions`]="{item}">
                                        <v-btn
                                            class="delete ma-1"
                                            icon
                                            small
                                            dark
                                            @click="showModelNumberConfirmDialog(item)"
                                        >
                                            <v-icon size="16">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-form>
        </div>
        <new-code-model
            :visible="showNewCodeModelForm"
            @close="showNewCodeModelForm = false"
            @modelCreated="handleUpdate"
        >
        </new-code-model>

        <confirm-delete
            :message="$t('sites.going_to_delete', [designation])"
            :visible="site_confirm_dialog"
            @close="site_confirm_dialog = false"
            @validate="deleteSite"
        />

        <confirm-delete
            :message="$t('model_numbers.going_to_delete', [modelNumberToDelete.code])"
            :visible="modelConfirmDialog"
            @close="modelConfirmDialog = false"
            @validate="deleteModel(modelNumberToDelete.id)"
        />
    </v-col>
</template>

<script>
import NewCodeModel from "./new_code_model";
import ConfirmDelete from "../../../components/dialogs/confirmDelete";

export default {
    name: "EditSite",
    components: {NewCodeModel, ConfirmDelete},

    data() {
        return {
            designation: null,
            code: null,
            headers: [
                {
                    text: this.$t("sites.code"),
                    align: "start",
                    sortable: true,
                    value: "code",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
            models: [],
            showNewCodeModelForm: false,
            modelLoading: false,
            site_confirm_dialog: false,
            modelConfirmDialog: false,
            modelNumberToDelete: {}
        };
    },

    mounted() {
        const id = this.$route.params.id
        this.getSite(id)
        this.getSiteTourModel(id)
    },

    methods: {
        async getSite(id) {
            const site = (await this.$api.sites.get(id)).data.data
            this.designation = site.label
            this.code = site.code
        },
        async getSiteTourModel(id) {
            try {
                this.modelLoading = true
                this.models = (await this.$api.site_model_number.all(id)).data.data
                this.modelLoading = false
            } catch (e) {
                this.modelLoading = false
            }
        },
        async handleUpdate(model) {
            await this.$api.site_model_number.create(this.$route.params.id, model).then(({data: model}) => this.addModel(model.data))
        },
        async deleteModel(id) {
            await this.$api.site_model_number.delete(this.$route.params.id, id).then(() => {
                this.models = this.models.filter(function (model) {
                    return model.id !== id
                })
            });

            this.modelConfirmDialog = false;
        },
        deleteSite() {
            try {
                this.$api.sites.delete(this.$route.params.id).then(() => this.$router.push({name: 'sites'}))
            } catch (e) {
                return
            }

            this.models.each(async model => {
                await this.deleteModel(model.id)
            })
        },
        addModel(model) {
            this.models.push(model)
        },
        showModelNumberConfirmDialog(modelNumberToDelete) {
            this.modelConfirmDialog = true;
            this.modelNumberToDelete = modelNumberToDelete;
        }
    },
};
</script>
